import styled from 'styled-components';

import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { rem } from '@savgroup-front-common/primitive/helpers/units';

export const $ResumeCardContainer = styled.div`
  background: ${({ theme }) => theme.colors.default};
  border-radius: ${({ theme }) => theme.tw.radius.lg};
  padding: ${spacing(5)} ${spacing('xl')};
  height: fit-content;
`;

export const $ResumeDescriptionProduct = styled.div`
  display: flex;
  margin-bottom: ${spacing(3.5)};

  &:last-child {
    margin-bottom: 0;
  }
`;
export const $ResumePictureProduct = styled.div``;
export const $CardContentThumbnailWrapper = styled.div``;
export const $CardContentThumbnail = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.disabled};
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  margin-right: ${spacing('lg')};
  padding: ${spacing('xxs')};
  max-width: ${spacing(10)};
  max-height: ${spacing(10)};
  overflow: hidden;
  img {
    object-fit: contain;
    max-height: ${rem(60)};
    max-width: ${rem(60)};
  }
`;

export const $ResumeProductTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing('sm')};
`;

export const $ResumeProductTitle = styled.div`
  font-weight: ${fontWeight('medium')};
  ${fontStyle('base')};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.systemColors.defaultTextColor};
`;

export const $ResumeInfoProduct = styled.div``;

export const $ResumeInfoProductTitle = styled.div`
  font-weight: ${fontWeight('medium')};
  ${fontStyle('base')};
  line-height: 19px;
  color: ${({ theme }) => theme.systemColors.defaultTextColor};
`;

export const $ResumeInfoProductTag = styled.div`
  font-weight: 700;
  ${fontStyle('xxs')};
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.success};
`;

export const $ResumeSeparator = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.disabled};
  width: 100%;
  height: 0;
  margin: ${spacing(3.5)} 0;
`;

export const $ResumeStateProduct = styled.div`
  margin-bottom: ${spacing(3.5)};
`;

export const $ResumeStateProductReason = styled.div`
  font-weight: ${fontWeight('normal')};
  ${fontStyle('xs')};
  line-height: 20px;
  color: ${({ theme }) => theme.colors.paragraphTextColor};
`;
